import React from "react";
import "./style.scss";

export default function NoPermission(props) {
  return (
    <div className="no_permission">
      <i className="empty_img"></i>
      <div className="no_tips">{props.content}</div>
      {
        props.isshow
        ?
        <div className="to_connect">请联系运营人员签订合同后绑定</div>
        :
        ''
      }
    </div>
  );
}
